import { Layout } from "@components/Account/Wallet/Layout";

export default Layout;
